import {SnackbarProgrammatic as Snackbar} from 'buefy'

const toaster = function () {}

toaster.error = function (params) {
    return new Promise(resolve => {
        params.message = params.message || 'Unknown error'
        params.type = params.type || 'is-danger'
        params.position = params.position || 'is-top'
        params.queue = params.queue || false
        params.onAction = resolve
        Snackbar.open(params)
    })
}

toaster.catch = function (vue) {
    return function (err) {
        if (err?.response?.data?.code) {
            const message = vue.$i18n.t('error.'+err?.response?.data?.code, err?.response?.data?.params || [])
            toaster.error({message})
        } else {
            const message = err?.response?.data?.message || err
            // noinspection JSIgnoredPromiseFromCall
            toaster.error({message})
        }
    }
}

export default toaster
